<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addShop">新建门店</el-button>
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="shopList" style="width: 100%">
            <el-table-column label="门店ID" width="130">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.shopStoreId }}</div>
              </template>
            </el-table-column>
            <el-table-column label="门店名称">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.storeName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="店铺名称">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.shopName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="地址">
              <template slot-scope="scope">
                <div>{{ scope.row.storeAddress }}</div>
              </template>
            </el-table-column>
            <el-table-column label="店铺地址">
              <template slot-scope="scope">
                <div>{{ scope.row.shopAddress }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button
                    size="small"
                    type="primary"
                    v-if="scope.row.shopId"
                    @click="addQrCodeJumpIndex(scope.row)"
                    >首页码</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    v-if="scope.row.shopId"
                    @click="addQrCodeJumpPay(scope.row)"
                    >付款码</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    v-if="!scope.row.shopId"
                    @click="opening(scope.$index)"
                    plain
                    >开通</el-button
                  >
                  <el-button
                    size="small"
                    type="danger"
                    v-if="!scope.row.isMaster && scope.row.shopId"
                    @click="close(scope.$index)"
                    plain
                    >停用</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    v-if="scope.row.shopId"
                    @click="editShop(scope.$index)"
                    plain
                    >编辑</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogBindShopVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      @close="resetForm"
    >
      <div slot="title" class="dialog-title">
        {{
          shopForm.shopStoreId ? (shopForm.shopId ? "编辑店铺" : "开通店铺") : "新建店铺"
        }}
      </div>
      <el-form
        :model="shopForm"
        :rules="rules"
        ref="shopForm"
        label-width="88px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
        :validate-on-rule-change="false"
      >
        <div>
          <el-form-item label="店铺logo" prop="shopLogo">
            <div>
              <el-upload
                :disabled="uploadDisabled"
                action="/ImageServer/YmUpload_image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'shopLogo');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'shopLogo');
                  }
                "
                :before-upload="beforeImgUpload"
                :file-list="shopLogo"
                :on-exceed="limitTip"
                :limit="1"
              >
                <div
                  style="width: 148px; height: 148px; position: absolute"
                  @click="show_uploadDialog(1, 'shopLogo')"
                ></div>
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="店铺名称" prop="storeName">
            <el-input
              v-model="shopForm.storeName"
              placeholder="请填写店铺名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="店铺公告" prop="shopNotice">
            <el-input
              type="textarea"
              placeholder="请填写店铺公告"
              v-model="shopForm.shopNotice"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="shopTel">
            <el-input v-model="shopForm.shopTel" placeholder="请填写联系电话"></el-input>
          </el-form-item>
          <!-- <el-form-item label="门店所在地" prop="cityName">
            <el-cascader
              v-model="shopForm.cityName"
              @change="cityNameCascaderHandler"
              :options="cityOptions"
              :props="{ expandTrigger: 'click', value: 'label' }"
              placeholder="请选择门店所在地"
            ></el-cascader>
          </el-form-item> -->
          <el-form-item label="详细地址" prop="storeAddress">
            <el-input v-model="shopForm.storeAddress" placeholder="请填写店铺地址">
              <!-- <template slot="append">
                <el-button @click="showDialogMap">去定位</el-button>
              </template> -->
            </el-input>
          </el-form-item>
          <el-form-item label="经纬度:" prop="center">
            <el-input
              v-model="mapCenterInputText"
              placeholder="请填写经纬度"
              @blur="mapCenterInputTextBlur(shopForm)"
            >
              <template slot="append">
                <el-button type="primary" @click="showDialogMap()">去获取</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="门脸照片" prop="shopFaceImage">
            <div>
              <el-upload
                :disabled="uploadDisabled"
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'shopFaceImage');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'shopFaceImage');
                  }
                "
                :before-upload="beforeImgUpload"
                :file-list="shopFaceImage"
                :on-exceed="limitTip"
                :limit="1"
              >
                <div
                  style="width: 148px; height: 148px; position: absolute"
                  @click="show_uploadDialog(1, 'shopFaceImage')"
                ></div>
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="店铺实景 (可多图)" prop="shopImages">
            <div>
              <el-upload
                :disabled="uploadDisabled"
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'shopImages');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'shopImages');
                  }
                "
                :before-upload="beforeImgUpload"
                :file-list="shopImages"
                :before-remove="beforeRemove"
              >
                <div
                  style="width: 148px; height: 148px; position: absolute"
                  @click="show_uploadDialog(999, 'shopImages')"
                ></div>
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="店铺头部 （背景图）" prop="bannerImage">
            <div>
              <span class="tips">（图片建议像素：702x234）</span>
              <el-upload
                :disabled="uploadDisabled"
                class="banner-image"
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'bannerImage');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'bannerImage');
                  }
                "
                :before-upload="beforeImgUpload"
                :file-list="bannerImage"
                :on-exceed="limitTip"
                :limit="1"
              >
                <div
                  style="width: 148px; height: 148px; position: absolute"
                  @click="show_uploadDialog(1, 'bannerImage')"
                ></div>
                <i class="el-icon-plus"></i>
              </el-upload>

              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </div>
          </el-form-item>
          <el-form-item label="店铺形象图 （背景）" prop="indexBackgroundImage">
            <div>
              <el-upload
                :disabled="uploadDisabled"
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'indexBackgroundImage');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'indexBackgroundImage');
                  }
                "
                :before-upload="beforeImgUpload"
                :file-list="indexBackgroundImage"
                :on-exceed="limitTip"
                :limit="1"
              >
                <div
                  style="width: 148px; height: 148px; position: absolute"
                  @click="show_uploadDialog(1, 'indexBackgroundImage')"
                ></div>
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <el-dialog
        width="510px"
        :visible.sync="dialogMapVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :append-to-body="true"
      >
        <div slot="title" class="dialog-title">地图定位</div>
        <!-- <baidu-map
          v-if="dialogMapVisible"
          class="map"
          :center="center"
          :zoom="zoom"
          @ready="mapReadyHandler"
          @click="getPoint"
          :scroll-wheel-zoom="true"
        >
          <bm-control :offset="{ width: '10px', height: '10px' }">
            <el-input v-model="keyword" placeholder="请输入地名关键字"></el-input>
          </bm-control>
          <bm-local-search
            :keyword="keyword"
            :auto-viewport="true"
            :location="location"
            zoom="12.8"
            style="display: none"
          ></bm-local-search>
          <bm-marker :position="postionMap">
            <bm-info-window
              :show="show"
              @close="infoWindowClose"
              @open="infoWindowOpen"
              style="font-size: 14px"
            >
              <p>站点：{{ add.siteName }}</p>
              <p>站点地址：{{ add.site }}</p>
            </bm-info-window>
          </bm-marker>
        </baidu-map> -->
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveStationAddress">保存</el-button>
        </div>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('shopForm')" :loading="isSubmit">
          {{
            shopForm.shopStoreId ? (shopForm.shopId ? "编辑" : "立即开通") : "立即创建"
          }}</el-button
        >
        <el-button @click="dialogBindShopVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- <baidu-map v-if="showMap" class="index-map"></baidu-map> -->
    <uploadImgComponent
      :isshow_uploadDialog="isshow_uploadDialog"
      @onClose="close_uploadDialog"
      @getChoose_ImgUrl="getChoose_ImgUrl"
      ref="childRef"
      :ImgLimits="ImgLimits"
      :uploadName="uploadName"
    ></uploadImgComponent>
    <div
      class="popup"
      :class="{
        show: isShowUrlQrcode,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>{{ qrcodeType == "index" ? "首页码" : "付款码" }}</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowUrlQrcode = false"
          />
        </div>
        <div class="popup-container">
          <qrcode :value="urlQrcode" :options="{ size: 300 }" class="qrcode"></qrcode>
          <el-button type="primary" @click="downPayCode"
            >下载{{ qrcodeType == "index" ? "首页码" : "付款码" }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getShopInfo,
  createOrUpdateShopStore,
  getShopStoresTotalNum,
  getShopList,
  uniformQrCode,
  closeShopStore,
} from "@/api";
import cityJson from "@/assets/js/citys.json";
import uploadImgComponent from "@/components/uploadImg";
import { gg2bd, bd2gg } from "@/utils/map.js";
import { mapState } from "vuex";
import qrcode from "@xkeshi/vue-qrcode";
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      isShowUrlQrcode: false,
      urlQrcode: "",
      qrcodeType: "index",
      shopList: [],
      isSubmit: false,
      pageNo: 1,
      pageSize: 5,
      pageCount: 0,
      dialogBindShopVisible: false,
      dialogImageUrl: "",
      dialogVisible: false,
      shopForm: {
        shopLogo: "",
        edcShopQRcode: "",
        storeName: "",
        shopNotice: "",
        shopTel: "",
        businessHours: "07:00-22:30",
        startTime: "",
        endTime: "",
        cityName: "",
        storeAddress: "",
        edcfuncTags: "",
        takeoutStatus: true,
        tangStatus: true,
        shopCategoryIdTags: [1, 1],
        needChoosePeopleNum: 1,
        payMethod: 1,
        isAutoClearTable: 1,
        isAutoOrderNumber: 1,
        mealMethod: 1,
        sendScope: "",
        sendType: 1,
        distributionPrice: "",
        minDistributionPrice: "",
        toSendPrice: "",
        shopFaceImage: "",
        shopImages: "",
        bannerImage: "",
        indexBackgroundImage: "",
        isVerified: 0,
        nuonuoTaxNum: "",
        edcShopType: 1,
      },
      rules: {
        shopLogo: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        storeName: [
          {
            required: true,
            message: "请填写店铺名称",
            trigger: "blur",
          },
        ],
        shopNotice: [
          {
            required: true,
            message: "请填写店铺公告",
            trigger: "blur",
          },
        ],
        shopTel: [
          {
            required: true,
            message: "请填写联系电话",
            trigger: "blur",
            pattern: /(^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$)|(^\d{2,4}-\d{7,8}$)/,
          },
        ],
        cityName: [
          {
            required: true,
            message: "请选择门店所在地",
            trigger: "blur",
          },
        ],
        shopFaceImage: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        shopImages: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        indexBackgroundImage: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
      },
      isshow_uploadDialog: false,
      uploadDisabled: false,
      ImgLimits: 1,
      uploadName: "",
      shopLogo: [],
      shopFaceImage: [],
      shopImages: [],
      bannerImage: [],
      indexBackgroundImage: [],
      dialogMapVisible: false,
      showMap: false,
      mapCenter: "",
      center: { lng: 0, lat: 0 },
      zoom: 12.8,
      cityOptions: cityJson,
      keyword: "",
      location: "",
      show: false,
      postionMap: {
        //地图坐标
        lng: 120.211486,
        lat: 30.256576,
      },
      add: {
        siteName: "",
        site: "",
        jd: "",
        wd: "",
        desce: "",
        type: "",
        jgName: "",
        jgNum: "",
      },
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
  },
  components: {
    uploadImgComponent,
    qrcode,
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData(type = "") {
      if (type == "create") {
        this.pageNo = Math.ceil((this.pageCount + 1) / this.pageSize);
      }
      this.getShopList();
      this.getShopStoresTotalNum();
    },
    getShopList() {
      getShopList({
        shopStoreId: "",
        pageNo: this.pageNo,
        row: this.pageSize,
      }).then((res) => {
        if (res.code == 1) {
          this.shopList = res.data;
        }
      });
    },
    getShopStoresTotalNum() {
      getShopStoresTotalNum({
        shopStoreId: "",
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPageData();
    },
    info(index) {},
    addShop() {
      //   this.initForm(() => {
      let shopForm = JSON.parse(JSON.stringify(this.shopForm));
      this.shopForm.edcShopType = this.shop.edcShopType;
      shopForm.storeName = "";
      shopForm.storeAddress = "";
      shopForm.shopStoreId = "";
      this.shopForm = shopForm;
      this.dialogBindShopVisible = true;
      //   });
    },
    opening(ind) {
      //   this.initForm(() => {
      let shopForm = JSON.parse(JSON.stringify(this.shopList[ind]));
      this.shopForm.edcShopType = this.shop.edcShopType;
      this.shopForm.storeName = shopForm.storeName;
      this.shopForm.storeAddress = shopForm.storeAddress;
      this.shopForm.shopStoreId = shopForm.shopStoreId;
      this.shopForm.longitude = shopForm.longitude || 0;
      this.shopForm.latitude = shopForm.latitude || 0;
      this.dialogBindShopVisible = true;
      //   });
    },
    close(index) {
      closeShopStore({
        shopStoreId: this.shopList[index].shopStoreId,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "停用成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
        }
      });
    },
    editShop(ind) {
      this.showMap = true;
      console.log(this.shopList[ind], this.shopList[ind].shopStoreId, ind);
      getShopInfo({
        shopStoreId: this.shopList[ind].shopStoreId,
      }).then((shopInfo) => {
        this.showMap = false;
        let shopForm = JSON.parse(JSON.stringify(shopInfo.data));
        let { lng, lat } = gg2bd(shopForm.longitude, shopForm.latitude);
        this.mapCenterInputText = `${shopForm.longitude},${shopForm.latitude}`;
        // this.mapCenter = shopForm.cityName.join("");
        this.shopLogo = shopForm.shopLogo.length ? [{ url: shopForm.shopLogo }] : [];
        this.shopFaceImage = shopForm.shopFaceImage.length
          ? [{ url: shopForm.shopFaceImage }]
          : [];
        this.bannerImage = shopForm.bannerImage.length
          ? [{ url: shopForm.bannerImage }]
          : [];
        this.indexBackgroundImage = shopForm.indexBackgroundImage.length
          ? [{ url: shopForm.indexBackgroundImage }]
          : [];
        let shopImages = shopForm.shopImages.split(",");
        if (shopImages[0].length) {
          shopImages.forEach((val) => {
            this.shopImages.push({
              name: val,
              url: val,
            });
          });
        }
        console.log(this.shopImages);
        shopForm.startTime = shopForm.businessHours.split("-")[0];
        shopForm.endTime = shopForm.businessHours.split("-")[1];
        shopForm.takeoutStatus = ~shopForm.edcfuncTags.indexOf("1") ? true : false;
        shopForm.tangStatus = ~shopForm.edcfuncTags.indexOf("2") ? true : false;
        let shopCategoryIdTags = shopForm.shopCategoryIdTags.split(",").map((val) => {
          return Number(val);
        });
        shopForm.shopCategoryIdTags = shopCategoryIdTags;
        let shopListInd = this.shopList[ind];
        shopForm.storeName = shopListInd.storeName;
        shopForm.storeAddress = shopListInd.storeAddress;
        this.shopForm = shopForm;
        console.log(this.shopForm);
        this.dialogBindShopVisible = true;
        // let point = new BMap.Point(lng, lat);
        // let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
        // geocoder.getLocation(point, (rs) => {
        //   shopForm.cityName = [
        //     rs.addressComponents.province,
        //     rs.addressComponents.city,
        //     rs.addressComponents.district,
        //   ];
        //   console.log([
        //     rs.addressComponents.province,
        //     rs.addressComponents.city,
        //     rs.addressComponents.district,
        //   ]);
        // });
      });
    },
    initForm(cb) {
      this.showMap = true;
      let shopForm = JSON.parse(JSON.stringify(this.shop));
      setTimeout(() => {
        this.showMap = false;
        let { lng, lat } = gg2bd(shopForm.longitude, shopForm.latitude);
        let point = new BMap.Point(lng, lat);
        let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
        geocoder.getLocation(point, (rs) => {
          shopForm.cityName = [
            rs.addressComponents.province,
            rs.addressComponents.city,
            rs.addressComponents.district,
          ];
          this.mapCenter = shopForm.cityName.join("");
          this.shopLogo = shopForm.shopLogo.length ? [{ url: shopForm.shopLogo }] : [];
          this.shopFaceImage = shopForm.shopFaceImage.length
            ? [{ url: shopForm.shopFaceImage }]
            : [];
          this.bannerImage = shopForm.bannerImage.length
            ? [{ url: shopForm.bannerImage }]
            : [];
          this.indexBackgroundImage = shopForm.indexBackgroundImage.length
            ? [{ url: shopForm.indexBackgroundImage }]
            : [];
          let shopImages = shopForm.shopImages.split(",");
          if (shopImages[0].length) {
            shopImages.forEach((val) => {
              this.shopImages.push({
                name: val,
                url: val,
              });
            });
          }
          shopForm.startTime = shopForm.businessHours.split("-")[0];
          shopForm.endTime = shopForm.businessHours.split("-")[1];
          shopForm.takeoutStatus = ~shopForm.edcfuncTags.indexOf("1") ? true : false;
          shopForm.tangStatus = ~shopForm.edcfuncTags.indexOf("2") ? true : false;
          let shopCategoryIdTags = shopForm.shopCategoryIdTags.split(",").map((val) => {
            return Number(val);
          });
          shopForm.shopCategoryIdTags = shopCategoryIdTags;
          this.shopForm = shopForm;
          cb && cb();
        });
      }, 500);
    },
    getChoose_ImgUrl(val, name) {
      console.log(val, name);
      if (val.length > 0) {
        this.isshow_uploadDialog = false;
        this.uploadDisabled = false;
        val.forEach((item) => {
          if (name == "shopImages") {
            if (this.shopForm[name].length) {
              this.shopForm[name] += `,${item.image}`;
            } else {
              this.shopForm[name] = item.image;
            }
            this.shopImages.push({ name: "", url: item.image });
            return;
          }
          this.shopForm[name] = item.image;
          switch (name) {
            case "shopLogo":
              this.shopLogo = [];
              this.shopLogo.push({ name: "", url: item.image });
              break;
            case "shopFaceImage":
              this.shopFaceImage = [];
              this.shopFaceImage.push({ name: "", url: item.image });
              break;
            case "bannerImage":
              this.bannerImage = [];
              this.bannerImage.push({ name: "", url: item.image });
              break;
            case "indexBackgroundImage":
              this.indexBackgroundImage = [];
              this.indexBackgroundImage.push({ name: "", url: item.image });
              break;
            default:
              console.log("111");
          }
        });
      }
    },
    close_uploadDialog() {
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
    },
    show_uploadDialog(val, name) {
      console.log(val, name);
      this.ImgLimits = val;
      this.uploadName = name;
      this.isshow_uploadDialog = true;
      this.uploadDisabled = true;
      this.$refs.childRef.rSelect = []; //  每次打开清除上一次的选择
    },
    mapReadyHandler({ BMap, map }) {
      this.center = this.mapCenter;
      console.log(this.mapCenter);
      this.zoom = 12.8;
    },
    getPoint(e) {
      //点击地图获取一些信息，
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.shopForm.cityName = [
          rs.addressComponents.province,
          rs.addressComponents.city,
          rs.addressComponents.district,
        ];
        this.add.site = rs.address;
        this.add.lng = rs.point.lng;
        this.add.lat = rs.point.lat;
        this.shopForm.storeAddress = rs.address;
        let { lng, lat } = bd2gg(rs.point.lng, rs.point.lat);
        this.shopForm.longitude = lng;
        this.shopForm.latitude = lat;
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleSuccess(item, name) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          if (name == "shopImages") {
            if (this.shopForm[name].length) {
              this.shopForm[name] += `,${res.data.url}`;
            } else {
              this.shopForm[name] = res.data.url;
            }
            return;
          }
          this.shopForm[name] = res.data.url;
        }
      });
    },
    submitForm(formName, cb) {
      console.log(this.shopForm, "shopForm");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let shopForm = JSON.parse(JSON.stringify(this.shopForm));
          if (!shopForm.longitude) {
            return this.$notify({
              title: "提示",
              message: "请手动定位",
              type: "error",
              duration: 2000,
            });
          }
          //   shopForm.businessHours = `${shopForm.startTime}-${shopForm.endTime}`;
          shopForm.edcfuncTags = "";
          shopForm.shopCategoryId = shopForm.shopCategoryIdTags[1] || "";
          shopForm.shopCategoryIdTags = shopForm.shopCategoryIdTags.join(",");
          shopForm.cityName = JSON.stringify(shopForm.cityName);
          shopForm.bannerImage = shopForm.bannerImage.length
            ? shopForm.bannerImage
            : "https://api.yichengshi.cn/images/edcmobile/default_banner.png";
          shopForm.coodinateSystemType = 4;
          shopForm.shopName = shopForm.storeName;
          shopForm.shopAddress = shopForm.storeAddress;
          createOrUpdateShopStore(shopForm).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
              this.dialogBindShopVisible = false;
              this.getPageData(this.shopForm.shopStoreId ? "" : "create");
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
                duration: 2000,
              });
            }
          });
        } else {
          this.$notify({
            title: "提示",
            message: "表单未完善，请检查店铺设置",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    limitTip(files, fileList) {
      this.$notify({
        title: "警告",
        message: "只能上传一张图片，请删除图片后再上传",
        type: "warning",
        duration: 6000,
      });
    },
    cityNameCascaderHandler(value) {
      console.log(value);
      this.mapCenter = value.join("");
    },
    // showDialogMap() {
    //   if (!this.shopForm.cityName) {
    //     this.$notify({
    //       title: "警告",
    //       message: "请先选择城市",
    //       type: "warning",
    //       duration: 6000,
    //     });
    //     return;
    //   }
    //   this.dialogMapVisible = true;
    // },
    beforeRemove(file, fileList) {},
    saveStationAddress() {
      this.dialogMapVisible = false;
    },
    createBindShop() {},
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    resetForm() {
      (this.shopForm = {
        shopLogo: "",
        edcShopQRcode: "",
        shopName: "",
        shopNotice: "",
        shopTel: "",
        businessHours: "07:00-22:30",
        startTime: "",
        endTime: "",
        cityName: "",
        shopAddress: "",
        edcfuncTags: "",
        takeoutStatus: true,
        tangStatus: true,
        shopCategoryIdTags: [1, 1],
        needChoosePeopleNum: 1,
        payMethod: 1,
        isAutoClearTable: 1,
        isAutoOrderNumber: 1,
        mealMethod: 1,
        sendScope: "",
        sendType: 1,
        distributionPrice: "",
        minDistributionPrice: "",
        toSendPrice: "",
        shopFaceImage: "",
        shopImages: "",
        bannerImage: "",
        indexBackgroundImage: "",
        isVerified: this.shopForm.isVerified,
        latitude: 0,
        longitude: 0,
      }),
        (this.shopLogo = []);
      this.shopFaceImage = [];
      this.shopImages = [];
      this.bannerImage = [];
      this.indexBackgroundImage = [];
      this.mapCenterInputText = "";
      this.$refs.shopForm.resetFields();
    },
    addQrCodeJumpIndex(shop) {
      console.log(shop);
      uniformQrCode({
        mtype: 1,
        moreQrParams: `shopId=${shop.shopId}`,
      }).then((res) => {
        if (res.code == 1) {
          this.urlQrcode = res.data.url;
          this.isShowUrlQrcode = true;
          this.qrcodeType = "index";
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    addQrCodeJumpPay(shop) {
      uniformQrCode({
        mtype: 2,
        moreQrParams: `shopId=${shop.shopId}`,
      }).then((res) => {
        if (res.code == 1) {
          this.urlQrcode = res.data.url;
          this.isShowUrlQrcode = true;
          this.qrcodeType = "pay";
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    downPayCode() {
      let canvas = document.querySelector(".qrcode");
      let dataURL = canvas.toDataURL("image/png");
      let a = document.createElement("a"); // 创建一个a节点插入的document
      let event = new MouseEvent("click"); // 模拟鼠标click点击事件
      a.download = this.qrcodeType == "index" ? "indexQrcode.png" : "payQrcode.png"; // 设置a节点的download属性值
      a.href = dataURL; // 将图片的src赋值给a节点的href
      a.dispatchEvent(event);
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .list {
    width: 100%;
    padding: 0 20px;
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
.popup-container {
  text-align: center;
  padding-bottom: 10px;
  .qrcode {
    display: block;
    margin: 10px;
  }
}
</style>
